import BVASwitch from "../BVASwitch/BVASwitch";
import {useEffect, useState} from "react";

export default function BVASplitter({
  itemName,
  itemValue,
  key,
  itemSplitAmount,
  itemSplitValue,
  onChange = () => ({})
}) {
  // States
  const [internalValue, setInternalValue] = useState(0)

  // Watchers
  useEffect(() => {
    setInternalValue(itemSplitValue)
  }, [itemSplitValue])

  // Methods
  const handleSwitchOnChange = (value) => {
    setInternalValue(+value)
    onChange(+value)
  }


  return (
    <div className="w-full flex align-center items-center justify-between">
      <div className="w-80">
        <label className={internalValue === 0 ? 'text-neutral-800' : 'text-neutral-400'}>{itemName}</label>
      </div>
      <div className={`w-40 text-center ${internalValue === 0 ? 'opacity-1' : 'opacity-0'}`}>
        <label>{itemSplitAmount}</label>
      </div>
      <div className="flex justify-center w-40">
        <BVASwitch value={!!internalValue} onChange={handleSwitchOnChange} />
      </div>
      <div className="w-80 flex">
        <label className={internalValue === 1 ? 'text-neutral-800 text-right' : 'text-right text-neutral-400'}>{itemName}</label>
      </div>
      <div className={`w-40 text-center justify-end ${internalValue === 1 ? 'opacity-1' : 'opacity-0'}`}>
        <label>{itemSplitAmount}</label>
      </div>
    </div>
  )
}